import { render, staticRenderFns } from "./DraggableContainer.vue?vue&type=template&id=634be5e7&"
import script from "./DraggableContainer.vue?vue&type=script&lang=js&"
export * from "./DraggableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports